<template>
    <div>
        <div id="menucard">
            <v-layout row wrap>
                <v-flex xs12 sm6 md4 lg3 v-for="card in this.menuCards" :key="card.id">
                    <v-card class="task-card" elevation="2">
                        <v-card-text class="pb-1">
                            <p class="task-title">{{ card.title }}</p>
                            <div class="task-content">{{ card.content }}</div>
                        </v-card-text>
                        <v-card-actions class="pt-0">
                            <v-btn text color="#4F6BFF" small @click="routesMenu(card.routes)" class="task-btn">{{ card.buttonWord }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </div>
        <!-- Overlay -->
        <div v-if="showOverlay" class="overlay">
            <div class="overlay-content">
                <h2 class="pb-3">{{ acknowledgement.longdesc }}</h2>
                <h4 class="pb-3"> Published on: {{ acknowledgement.publishDate }} </h4>
                <div class="terms-scroll">
                    <div v-html="acknowledgement.content"></div>
                </div>
                <div class="button-row">
                    <button class="ack-btn" @click="acceptAcknowledge">Acknowledge</button>
                    <button class="cancel-btn" @click="logoutHandler">Cancel</button>
                </div>
            </div>
        </div>
        <div v-if="isErr">
            <app-error v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
            }" v-on:closeError="isErr = $event" />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../components/common/ErrorDialog";
import moment from "moment";

export default {
    components: {
        "app-error": ErrorDialog,
    },
    data() {
        return {
            menuCards: [
                { id: 1, title: `${this.$t('selfservicescreen.mytask')}`, content: this.$t('selfservicescreen.actiontext'), buttonWord: this.$t('selfservicescreen.buttontext'), routes: 'selfservicemytask' }
            ],

            isErr: false,
            errMsg: "",

            // Acknowledgement 
            showOverlay: false,
            acknowledgement: {
                id: null,
                longdesc: null,
                content: null,
                publishDate: null,
            },

            acknowledgementAcceptance: {  //new acknowledgement acceptance record
                ackRecordId: null,
                staffId: null,
                companyId: null,
                psnId: this.$store.getters.psnId,
                userId: this.$store.getters.userId,
                acknowledgementDateTime: null,
                stamp: 0,
                updatedby: this.$store.getters.userId
            },
        }
    },

    methods: {
        routesMenu(route) {
            this.$router.push({ name: route });
        },

        Loadacknowledgement() {
            this.$store.dispatch('get', {
                url: `/validAcknowledgement/${this.$store.getters.psnId}/${this.$store.getters.userId}`
            })
                .then((res) => {
                    // console.log("ack", res.data.rec);
                    // console.log("what is the res result", res.data, "Full res", res);

                    // i should reconsider here for res.status thing
                    if (res.data.status == 500 || res.data.status == 404) {
                        this.isErr = true;
                        this.errMsg = res.data.error;
                    }
                    else if (res.data.status == 200) {
                        // console.log("the result", res.data.rec);
                        // Show Acknowledgement Overlay
                        this.acknowledgement.id = res.data.rec.acknowledgement.id;
                        this.acknowledgement.longdesc = res.data.rec.acknowledgement.ackLongDesc;
                        this.acknowledgement.content = res.data.rec.acknowledgement.content;
                        this.acknowledgement.publishDate = moment(res.data.rec.acknowledgement.publishDate).format("DD MMMM YYYY");
                        // console.log("acknowledgement value", this.acknowledgement);

                        //prepare new acknowledgement acceptance record, to save later
                        this.acknowledgementAcceptance.ackRecordId = res.data.rec.acknowledgement.id;
                        this.acknowledgementAcceptance.staffId = res.data.rec.staffId;
                        this.acknowledgementAcceptance.companyId = res.data.rec.companyId;

                        this.showOverlay = true;
                    }
                    else if (res.data.status == 204) {
                        // No pending acknowledgement to show
                        // console.log("No pending acknowledgement to show");
                    }
                    else {
                        this.isErr = true;
                        this.errMsg = "Unexpected response status while loading Acknowledgement: " + res.data.status;
                        console.log("Unexpected response:", res.data);
                    }
                })
                .catch((err) => {
                    this.isErr = true;
                    this.errMsg = err;
                });
        },

        acceptAcknowledge() {
            console.log("Acknowledge button clicked");
            console.log("now pass the acknowledgementAcceptance data", this.acknowledgementAcceptance);
            const vm = this;
            this.$store.dispatch('post', { url: "/acknowledgementacceptance/new", payload: this.acknowledgementAcceptance })
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = res.data.error;
                    } else {
                        // const id = res.data.newInsertedId;
                        // this.$router.push({ name: "acknowledgementedit", params: { id: id } });
                        this.showOverlay = false;
                        window.location.reload(); //reload page if there is another acknowledgement to show
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        logoutHandler() {
            this.$router.replace("/" + this.$i18n.locale + "/home/" + this.$store.getters.db);
            this.$store.dispatch("deleteToken");
        },
    },
    mounted() {
        // console.log("MenuCard component mounted.");

        if (this.$store.getters.psnId) { // valid psnId
            this.Loadacknowledgement();
        }
        else {
            console.log("No valid psnId to load Acknowledgement");
        }
    }
}

</script>

<style>
.task-card {
    background: #ffffff !important;
    border-radius: 12px !important;
    padding: 8px 4px 4px 4px;
    margin: 8px;
}

.task-title {
    font-size: 0.95rem !important;
    font-weight: 700 !important;
    color: #0D1B4B !important;
    letter-spacing: normal !important;
    margin-bottom: 6px !important;
}

.task-content {
    font-size: 0.82rem !important;
    color: #546e7a !important;
    letter-spacing: normal !important;
    line-height: 1.4 !important;
}

.task-btn {
    font-size: 0.78rem !important;
    font-weight: 600 !important;
    letter-spacing: normal !important;
    text-transform: none !important;
    padding-left: 4px !important;
}
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.overlay-content {
    background: white;
    width: 80%;
    height: 80%;
    max-height: 80%;
    padding: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
}

.terms-scroll {
    flex: 1;
    overflow-y: auto;
    overflow-x: auto;
    margin-bottom: 20px;
    padding: 15px;
    border: 1px solid #ccc;
    border-radius: 6px;
    background: #fafafa;
    line-height: 1.6;
    color: #333;
}

.ack-btn {
    align-self: center;
    padding: 12px 28px;
    background-color: #28a745;
    /* Green */
    color: white;
    font-weight: 600;
    font-size: 16px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.1s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.ack-btn:hover {
    background-color: #218838;
    /* Darker green on hover */
    transform: translateY(-1px);
}

.ack-btn:active {
    background-color: #1e7e34;
    /* Even darker when pressed */
    transform: translateY(1px);
}

.button-row {
    display: flex;
    justify-content: center;
    /* center horizontally */
    gap: 20px;
    /* space between buttons */
    margin-top: 20px;
}

.cancel-btn {
    padding: 12px 28px;
    background-color: #ffc107;
    /* Bootstrap warning color */
    color: #ffffff;
    /* dark text for contrast */
    font-weight: 600;
    font-size: 16px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.1s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.cancel-btn:hover {
    background-color: #e0a800;
    /* darker warning on hover */
    transform: translateY(-1px);
}

.cancel-btn:active {
    background-color: #d39e00;
    /* even darker when pressed */
    transform: translateY(1px);
}
</style>